/* eslint-disable react/display-name */
import React, { memo } from 'react';
import styled from 'styled-components';
import { smallMediaQuery, mediumMediaQuery } from '../../../../common/utilities/sizeHelpers';
import { LazyLoadImg } from '../../../../common/utilities/lazyLoadImg';

export const FooterDeviceStoreItem = memo(({ deviceLink, deviceImage, storeAriaLabel }) =>
{
    const alignToLeft = deviceLink?.includes('itunes.apple.com');
    return (
        <FooterDevicesContainer alignToLeft={alignToLeft}>
            <FooterDevicesLink 
                alignToLeft={alignToLeft}
                href={deviceLink}
                aria-label={storeAriaLabel}
                target='_blank' 
                rel='noopener'>
                <LazyLoadImg style={footerDeviceStoreImgStyle}
                    alt='WeatherBug store item image'
                    src={deviceImage}
                />
            </FooterDevicesLink>
        </FooterDevicesContainer>
    );
});

FooterDeviceStoreItem.DisplayName = 'FooterDeviceStoreItem';

const footerDeviceStoreImgStyle = {
    display: 'flex',
    width: 'auto',
    height: 50
};

const FooterDevicesLink = styled.a`
    display: flex;
    flex-direction: row;
    justify-content:  ${({ alignToLeft }) => alignToLeft ? 'flex-end' : 'flex-start'};
    min-width: 219px;

    @media ${smallMediaQuery} {
        justify-content: center;
    }
`;
const FooterDevicesContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content:  ${({ alignToLeft }) => alignToLeft ? 'flex-end' : 'flex-start'};
    align-items: center;
    padding: 5px;
    width: 100%;
    @media ${mediumMediaQuery} {
        padding: 12px;
    }

    @media ${smallMediaQuery} {
        justify-content: center;
    }
`;
